import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

// Config Module
import { environment } from 'src/environments/environment';
import { AttributeCode } from '../../setting-group/_models';
import { HttpUtilities } from 'src/app/common/helpers/http-utils.helper';

// Modules

@Injectable()
export class BrandService {
    headers: HttpHeaders;
    API_URI = environment.API_URI + '/v1/attribute-values';

    constructor(
        private http: HttpClient,
        private httpService: HttpUtilities
    ) {
        this.headers = this.httpService.getHttpClientHeaders();
    }

    /**
     * List
     *
     * @param {String} queryParams
     */
    list(params: any = {}) {
        delete params.page;
        //params.attribute_code = AttributeCode.PRODUCT_BRAND;
        return this.http.get(
            this.API_URI,
            {
                params: this.httpService.getFindHTTPParams(params),
                headers: this.headers
            }
        ).toPromise().then(
            result => JSON.parse(
                JSON.stringify(result)
            )
        );
    }

    /**
     * Create
     * @param {*} requestBody
     */
    create(requestBody: any = {}) {
        return this.http.post(
            this.API_URI,
            requestBody,
            {
                headers: this.headers
            }
        ).toPromise().then(
            result => JSON.parse(
                JSON.stringify(result)
            )
        );
    }

    /**
     * Detail
     * @param {String} brandId
     */
    detail(brandId: any) {
        return this.http.get(
            this.API_URI + `/${brandId}`,
            {
                headers: this.headers
            }
        ).toPromise().then(
            result => JSON.parse(
                JSON.stringify(result)
            )
        );
    }

    /**
     * Update
     * @param {String} brandId
     * @param {*} requestBody
     */
    update(brandId: string, requestBody: any = {}) {
        return this.http.put(
            this.API_URI + `/${brandId}`,
            requestBody,
            {
                headers: this.headers
            }
        ).toPromise().then(
            result => JSON.parse(
                JSON.stringify(result)
            )
        );
    }

    /**
     * Delete
     * @param {String} brandId
     */
    delete(brandId: string) {
        return this.http.delete(
            this.API_URI + `/${brandId}`,
            {
                headers: this.headers
            }
        ).toPromise().then(
            result => JSON.parse(
                JSON.stringify(result)
            )
        );
    }
}
